module.exports = __webpack_public_path__ + "img/portrait-090.419bb780.jpg";